const { REACT_APP_HELP_CRUNCH_ID } = process.env;

export const OPEN_CHAT = 'openChat';
export const TYPE_USER_MESSAGE = 'typeUserMessage';

let isInited = false;

export const HelpCrunch = {
  ID: REACT_APP_HELP_CRUNCH_ID,
  init() {
    window.helpcrunchSettings = {
      organization: 'belive',
      appId: REACT_APP_HELP_CRUNCH_ID,
    };

    (function(w,d){var hS=w.helpcrunchSettings;if(!hS||!hS.organization){return;}var widgetSrc='https://'+hS.organization+'.widget.helpcrunch.com/';w.HelpCrunch=function(){w.HelpCrunch.q.push(arguments)};w.HelpCrunch.q=[];function r(){if (d.querySelector('script[src="' + widgetSrc + '"')) { return; }var s=d.createElement('script');s.async=1;s.type='text/javascript';s.src=widgetSrc;(d.body||d.head).appendChild(s);}if(d.readyState === 'complete'||hS.loadImmediately){r();} else if(w.attachEvent){w.attachEvent('onload',r)}else{w.addEventListener('load',r,false)}})(window, document)
  },
  setUser(user) {
    window.HelpCrunch('updateUser', user);
  },
  track(name, json) {
    HelpCrunch.lazyInit();
    window.HelpCrunch('trackEvent', name, json);
  },
  lazyInit() {
    if (!isInited) {
      isInited = true;
      if (window.HelpCrunch) {
        window.HelpCrunch('init', 'belive', {
          applicationId: REACT_APP_HELP_CRUNCH_ID,
        });
      }
    }
  },
  getInstance: () => {
    HelpCrunch.lazyInit();
    return window.HelpCrunch ? window.HelpCrunch : null;
  },
};
